<script lang="ts">
	import { page } from '$app/stores';
	import NavigatorItem from './NavigatorItem.svelte';
	import { getStepper } from './stepper';

	const stepper = getStepper();
</script>

<nav
	class="h-full w-[88px] select-none self-stretch lg:w-1/2 {$stepper.showResult
		? 'hidden lg:block' + ($page.data.embed ? 'lg:hidden' : '')
		: ''}"
>
	<ul
		class="steps-center lg:steps-start flex h-full flex-col overflow-y-auto bg-light p-5 pb-16 lg:gap-8 lg:py-12 lg:pl-12 xl:pl-32"
	>
		{#if $stepper.steps}
			{#each $stepper.steps as step, i}
				{@const selectedBefore = i < $stepper.currentStep}
				<NavigatorItem
					on:click={() => {
						if (!$stepper.showResult && selectedBefore) stepper.goToStep(i);
					}}
					number={i + 1}
					title={step.title}
					caption={selectedBefore ? (step.displayCaption ? step.displayCaption(step) : null) : null}
					selected={i === $stepper.currentStep}
					selectedBefore={$stepper.showResult || selectedBefore}
					hideSeparator={$stepper.steps.length === i + 1}
				/>
			{/each}
		{/if}
	</ul>
</nav>
